module.exports = __webpack_public_path__ + "img/dianshouying.b84e1a54.png";